/* Общие действия, доступные с любого экрана: карточка заказа, карточка клиента, новая запись, кампания. */
import { useMemo } from "react";
import { useLayers } from "../ui/layers";
import { BookingModal, type BookingPrefill } from "../screens/booking/BookingModal";
import { ClientDrawer } from "../screens/clients/ClientDrawer";
import { OfferDrawer } from "../screens/offers/OfferDrawer";
import { OrderDrawer } from "../screens/order/OrderDrawer";

export interface Actions {
  openOrder: (orderId: string) => void;
  openClient: (customerId: string) => void;
  openBooking: (prefill?: BookingPrefill) => void;
  openOffer: (offerId: string) => void;
}

export function useActions(): Actions {
  const { replace } = useLayers();
  return useMemo(
    () => ({
      openOrder: (orderId) => void replace(<OrderDrawer key={orderId} orderId={orderId} />),
      openClient: (customerId) => void replace(<ClientDrawer key={customerId} customerId={customerId} />),
      openBooking: (prefill) => void replace(<BookingModal prefill={prefill} />),
      openOffer: (offerId) => void replace(<OfferDrawer key={offerId} offerId={offerId} />),
    }),
    [replace],
  );
}
